module.exports = __webpack_public_path__ + "img/Category.d00ad37f.svg";